export default "__VITE_ASSET__StG7yr13__"